import React from 'react';
import ReactDOM from 'react-dom/client';

/* Components ---------------------------*/
import App from './App';

/* Styling ---------------------------*/
import './assets/styles/global.scss';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
